import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ReservationModal from './ReservationModal';
import { ReactComponent as ViaLink } from '../../assets/images/ViaLink.svg';
import { motion } from 'framer-motion';

const HomeHero: React.FC = () => {
  const HERO_IMAGE_URL =
    process.env.REACT_APP_HOME_HERO_URL ||
    "/hero.webp"; // served from frontend/public
  const [isReservationOpen, setIsReservationOpen] = useState(false);

  const openReservation = () => setIsReservationOpen(true);
  const closeReservation = () => setIsReservationOpen(false);

  return (
    <div className="relative w-full h-screen flex items-center text-cream overflow-hidden">
      {/* Banner + Link container */}
      <div
        className="
          absolute bottom-4
          left-1/2
          transform -translate-x-1/2
          w-full
          md:w-3/4
          z-20
          space-y-4
        "
      >
        {/* Center the banner with minimal width */}
        {/* <div className="w-full flex justify-center">
          <NoteBanner />
        </div> */}

        {/* Full-width link */}
        <motion.a
          className="block w-full pt-4 text-center"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          href="https://www.viamaestra42.com/"
          target="_blank"
          rel="noreferrer noopener"
        >
          <ViaLink />
        </motion.a>
      </div>

      {/* Background image + overlay */}
      <img
        src={HERO_IMAGE_URL}
        alt="Home Hero"
        className="absolute inset-0 object-cover w-full h-full"
      />
      <div className="absolute inset-0 bg-maroon opacity-40 z-0" />

      {/* Hero text & buttons */}
      <div className="relative z-10 p-8 md:p-16 max-w-xl flex flex-col items-center md:items-start justify-center h-full ml-0 md:ml-40">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-satoshi tracking-wider mb-4 text-center md:text-left w-full">
          WELCOME TO
        </h1>
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-recia font-light mb-4 text-center md:text-left w-full">
          Via Maestra Enoteca
        </h2>
        <p className="text-lg md:text-xl lg:text-2xl font-satoshi mb-8 text-center md:text-left w-full">
          Your Community Wine Bar
        </p>

        <div className="flex flex-col space-y-4 items-center w-full">
        {/*
          <button
            className="w-48 py-3 bg-cream text-maroon font-satoshi rounded-full text-center"
            onClick={openReservation}
          >
            Reserve a Table
          </button>
          */}
          <Link
            to="tel:(805) 563-6311"
            className="w-48 py-3 bg-cream text-maroon font-satoshi rounded-full text-center"
          >
            Call to Reserve a Table
          </Link>
          <Link
            to="/contact-us"
            className="w-48 py-3 bg-cream text-maroon font-satoshi rounded-full text-center"
          >
            Visit Us
          </Link>
        </div>
      </div>

      <ReservationModal isOpen={isReservationOpen} onClose={closeReservation} />
    </div>
  );
};

const NoteBanner = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="
        inline-flex
        items-center
        bg-gold
        py-3
        px-4
        text-white
        rounded-full
      "
    >
      <p className="text-sm md:text-base font-satoshi">
        We are open! Parking lot beautification in progress.
      </p>
      {/*
        Optional CTA button:
        <div className="ml-2">
          <a
            href="/reservations"
            className="
              inline-block
              bg-maroon
              text-cream
              px-4 py-2
              rounded
              hover:bg-olive
              transition
            "
          >
            Reserve Now
          </a>
        </div>
      */}
    </motion.div>
  );
};

export default HomeHero;